export const shouldShowCompetitionFederationEnterHint = ({
  selectedIndex,
  rowIndex,
  suggestionsLength,
} = {}) => {
  if (!Number.isInteger(selectedIndex) || !Number.isInteger(rowIndex)) {
    return false;
  }

  if (!Number.isInteger(suggestionsLength) || suggestionsLength <= 0) {
    return false;
  }

  if (selectedIndex < 0 || selectedIndex >= suggestionsLength) {
    return false;
  }

  return selectedIndex === rowIndex;
};
